<script setup lang="ts">
import MultiSelectTabs from '@/components/_common/MultiSelectTabs.vue';
import { useDeviceStatusTabs } from '@/composables/useDeviceStatusTabs';
import type { TrackerListStatusContext } from '@/stores/useTrackersListStatusStore';

const props = withDefaults(
  defineProps<{
    context?: TrackerListStatusContext;
  }>(),
  {
    context: 'trackers',
  },
);

const { tabs, selectedStatuses } = useDeviceStatusTabs(props.context);
</script>

<template>
  <MultiSelectTabs
    v-model="selectedStatuses"
    :tabs="tabs"
    class="mb-4"
  />
</template>
